import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import './utils/AssetRescue.js';
import ReloadOnErrorBoundary from "./utils/ReloadOnErrorBoundary";

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { store, StoreContext } from './stores/store'
import { IntlProvider, load } from '@progress/kendo-react-intl';

import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';

import numbers from 'cldr-numbers-full/main/en-AU/numbers.json';
import currencies from 'cldr-numbers-full/main/en-AU/currencies.json';
import caGregorian from 'cldr-dates-full/main/en-AU/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/en-AU/dateFields.json';


dateFields.main['en-AU'].dates.fields.day.displayName = 'dd';
dateFields.main['en-AU'].dates.fields.month.displayName = 'mm';
dateFields.main['en-AU'].dates.fields.year.displayName = 'yyyy';

caGregorian.main['en-AU'].dates.calendars.gregorian.dateFormats.short = 'dd/MM/yyyy';

load(
  likelySubtags,
  currencyData,
  weekData,
  currencies,
  numbers,
  caGregorian,
  dateFields
);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StoreContext.Provider value={store}>
    <IntlProvider locale="en-AU" >
      <ReloadOnErrorBoundary reloadDelayMs={300}>
        <App />
      </ReloadOnErrorBoundary>
    </IntlProvider>
  </StoreContext.Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
